import {Session} from "@/api/common/Session";

export class StoreProxy {

    static getAuth($store){

        if ($store == null){
            return Session.get("auth");
        }
        else{
            return $store.state.auth;
        }

    }

    static setLogin($store, jwt, sessionId, profile){
        StoreProxy.__validateStore($store);
        $store.commit('setLogin', {jwt: jwt, sessionId: sessionId});
        $store.commit("setProfile", profile);

        Session.set("auth", $store.state.auth);
        Session.set("sessionId", sessionId);
    }

    static setLogout($store){
        StoreProxy.__validateStore($store);
        $store.commit("setLogout");
        Session.destroy();
    }

    static __validateStore($store){
        if ($store == null){
            throw new Error('[e473782] vuex store ($store) must be passed to this method');
        }
    }
}